export enum BillsInclusiveTypes {
    NOT_INCLUDED = 0,
    INCLUDED = 1,
    PARTIALLY_INCLUDED = 2,
    NOT_APPLICABLE = 3,
}
export const ReverseBillsInclusiveTypes = {
    [BillsInclusiveTypes.NOT_INCLUDED]: 'Collected by manager',
    [BillsInclusiveTypes.INCLUDED]: 'Included',
    [BillsInclusiveTypes.PARTIALLY_INCLUDED]: 'Partially included',
    [BillsInclusiveTypes.NOT_APPLICABLE]: 'Arranged by tenant',
}
